<template>
  <span class="item--color__price m-2">
    <b-skeleton v-if="isLoading" width="100%" />
    <template v-else>
      <template v-if="pricing.printable">
        {{ singlePrice | toCents | currency }}
      </template>
      <template class="item--color__price" v-else>{{
        null | currency
      }}</template>
    </template>
  </span>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "PrintModePrice",
  data() {
    return {
      singlePrice: 0,
    };
  },
  props: {
    currentColor: {
      type: Object,
      required: true,
    },
    printMode: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "currentCartItem",
      "current3DFile",
      "taxRate",
      "isBusinessCustomer",
    ]),
    pricing() {
      if (this.currentColor.pricing) {
        return this.currentColor.pricing;
      } else {
        return {
          price: {
            netPrice: 0,
            totalPrice: 0,
          },
          productionTimeDays: 0,
          isPrintable: true,
          tooLarge: false,
          tooSmall: false,
        };
      }
    },
  },
  watch: {
    pricing(value) {
      this.singlePrice = this.pricing.price.netPrice / (this.currentCartItem.quantity || 1);
    },
    isBusinessCustomer(value) {
      this.singlePrice =this.pricing.price.netPrice / (this.currentCartItem.quantity || 1);
    },
  },
  created() {
    this.singlePrice = this.pricing.price.netPrice / (this.currentCartItem.quantity || 1);

  },
  mounted() {
    //eventBus.$on('cartItemPricingInvalid', this.calculatePricing)
    console.log('select Pricing', this.pricing);
  },
  beforeDestroy() {
    //eventBus.$off('cartItemPricingInvalid', this.calculatePricing);
  },
};
</script>

<style scoped lang="scss">
</style>
